import React from 'react';
import { Button, Dropdown, Tag } from 'antd';
import { MoreOutlined } from '@ant-design/icons';

const statusColors = {
  Active: 'green',
  Draft: 'gold',
  Paused: 'red',
  Archived: 'volcano',
};

const mechanicStyles = {
  Gift: {
    border: '1px solid #D3ADF7',
    background: '#F9F0FF',
    color: '#531DAB',
  },
  'Discount + Gift': {
    border: '1px solid #FFBB96',
    background: '#FFF2E8',
    color: '#D4380D',
  },
  Discount: {
    border: '1px solid #FFE58F',
    background: '#FFFBE6',
    color: '#D48806',
  },
};



export const membershipColumns = [
  {
    title: 'Rule Name',
    dataIndex: 'ruleName',
    key: 'ruleName',
    width: 220,
    onHeaderCell: () => ({
      className: 'membership-rule-name-header',
    }),
    sorter: (a, b) => a.ruleName.localeCompare(b.ruleName),
    render: (text, record) => (
      <div>
        <div style={{ fontWeight: 600, color: '#1f2937' }}>{text}</div>
        <div style={{ color: '#3b82f6', fontSize: 12 }}>{record.description}</div>
      </div>
    ),
  },
  {
    title: 'Customer Group',
    dataIndex: 'customerGroup',
    key: 'customerGroup',
    width: 120,
    render: (value) => (
      <span style={{ textTransform: 'uppercase' }}>{value}</span>
    ),
  },
  {
    title: 'Mechanic',
    dataIndex: 'mechanic',
    key: 'mechanic',
    width: 150,
    render: (value) => {
      const style = {
        borderRadius: 'var(--Components-Tag-Global-borderRadiusSM, 4px)',
        border: mechanicStyles[value]?.border || 'var(--Components-Tag-Global-lineWidth, 1px) solid transparent',
        background: mechanicStyles[value]?.background || 'transparent',
        color: mechanicStyles[value]?.color || '#1f2937',
        borderWidth: 'var(--Components-Tag-Global-lineWidth, 1px)',
        padding: '0 8px',
      };

      return (
        <Tag style={{ ...style, textTransform: 'uppercase' }}>{value}</Tag>
      );
    },
  },
  {
    title: 'Area',
    dataIndex: 'area',
    key: 'area',
    width: 130,
    render: (value) => (
      <span style={{ textTransform: 'uppercase' }}>{value}</span>
    ),
  },
  {
    title: 'Store',
    dataIndex: 'store',
    key: 'store',
    width: 90,
  },
  {
    title: 'Priority',
    dataIndex: 'priority',
    key: 'priority',
    width: 80,
  },
  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
    width: 120,
    render: (value) => {
      const dotColor = {
        active: '#52C41A',
        draft: 'rgba(0,0,0,.25)',
        paused: '#FAAD14',
        archived: '#FF4D4F',
      }[String(value || '').toLowerCase()] || '#999';

      return (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, fontWeight: 500, color: '#1f2937' }}>
          <span
            style={{
              width: 10,
              height: 10,
              borderRadius: '50%',
              backgroundColor: dotColor,
              display: 'inline-block',
              boxShadow: '0 0 0 2px rgba(0,0,0,0.04)',
            }}
          />
          <span style={{ textTransform: 'uppercase' }}>{value}</span>
        </div>
      );
    },
  },
  {
    title: 'Start',
    dataIndex: 'start',
    key: 'start',
    width: 110,
  },
  {
    title: 'End',
    dataIndex: 'end',
    key: 'end',
    width: 110,
  },
  {
    title: 'Uses',
    dataIndex: 'uses',
    key: 'uses',
    width: 100,
  },
  {
    title: 'Updated',
    dataIndex: 'updated',
    key: 'updated',
    width: 110,
  },
  {
    title: 'Actions',
    key: 'actions',
    width: 110,
    render: () => (
      <Dropdown
        trigger={['click']}
        className='membership-rule-actions-dropdown'
        
        placement="bottomRight"
        menu={{
          className: 'membership-rule-actions-dropdown-menu',
          items: [
            { key: 'view', label: 'View' },
            { key: 'edit', label: 'Edit' },
            { key: 'duplicate', label: 'Duplicate' },
            { key: 'resume', label: 'Resume' },
            { key: 'archive', label: 'Archive' },
            { key: 'delete', label: 'Delete' },
          ],
        }}
      >
        <Button
          type="text"
          icon={<MoreOutlined />}
          className='membership-rule-actions-dropdown-button'
        />
      </Dropdown>
    ),
  },
];

export default membershipColumns;
